(<any>window).MPAEngineCustomApp = components.TotalExpoMPAEngineApplication.Component;
import * as components from './components';

export * from './components';
export * from '@emersya/mpa-engine/src/app/client/components/index';
import * as DONT_TREE_SHACK from '@emersya/mpa-engine/src/app/client/index';
import './index.scss';

void DONT_TREE_SHACK;